import { render, staticRenderFns } from "./IcoCamera.vue?vue&type=template&id=788021fa"
import script from "./IcoCamera.vue?vue&type=script&lang=js"
export * from "./IcoCamera.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports